<template>
  <div>
    <div class="ch-head">
      <div>
        <h1>个人信息</h1>
        <p>除手机号外可修改主体资料。提交后需总部审核通过才会生效。</p>
      </div>
    </div>

    <div v-if="pending" class="ch-panel warn-box">
      <p class="ch-note">已有待审核变更（提交于 {{ pending.createdAt || '—' }}），总部处理前不能再次提交。</p>
      <p class="ch-note">拟改主体：{{ pending.name }} · 法人 {{ pending.legalName || '—' }} · 地区 {{ pending.regionName || pending.regionCode || '—' }}</p>
    </div>

    <div class="ch-panel">
      <el-form label-width="100px" size="small" style="max-width:520px">
        <el-form-item label="手机号">
          <el-input :value="form.phone" disabled />
          <p class="hint">登录账号绑定手机号，不可修改</p>
        </el-form-item>
        <el-form-item label="主体名称"><el-input v-model="form.name" :disabled="!!pending" /></el-form-item>
        <el-form-item label="法人"><el-input v-model="form.legalName" :disabled="!!pending" /></el-form-item>
        <el-form-item label="身份证号"><el-input v-model="form.idCardNo" :disabled="!!pending" /></el-form-item>
        <el-form-item label="执照号"><el-input v-model="form.licenseNo" :disabled="!!pending" /></el-form-item>
        <el-form-item label="区划代码"><el-input v-model="form.regionCode" :disabled="!!pending" /></el-form-item>
        <el-form-item label="地区名"><el-input v-model="form.regionName" :disabled="!!pending" /></el-form-item>
        <el-form-item label="行业代码"><el-input v-model="form.industryCode" :disabled="!!pending" placeholder="行业服务商填写" /></el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" :disabled="!!pending || saving" @click="submit">提交审核</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getChannelProfile, submitChannelProfile } from '@/api/admin'

export default {
  name: 'PartnerProfile',
  data() {
    return {
      saving: false,
      pending: null,
      form: { phone: '', name: '', legalName: '', idCardNo: '', licenseNo: '', regionCode: '', regionName: '', industryCode: '' }
    }
  },
  created() { this.load() },
  methods: {
    async load() {
      const result = await getChannelProfile()
      const partner = (result && result.partner) || {}
      this.pending = result.pending || null
      this.form = {
        phone: partner.phone || '',
        name: partner.name || '',
        legalName: partner.legalName || '',
        idCardNo: partner.idCardNo || '',
        licenseNo: partner.licenseNo || '',
        regionCode: partner.regionCode || '',
        regionName: partner.regionName || '',
        industryCode: partner.industryCode || ''
      }
    },
    async submit() {
      if (!this.form.name || !String(this.form.name).trim()) {
        this.$message.warning('请填写主体名称')
        return
      }
      this.saving = true
      try {
        const body = {
          name: this.form.name,
          legalName: this.form.legalName,
          idCardNo: this.form.idCardNo,
          licenseNo: this.form.licenseNo,
          regionCode: this.form.regionCode,
          regionName: this.form.regionName,
          industryCode: this.form.industryCode
        }
        await submitChannelProfile(body)
        this.$message.success('已提交，等待总部审核')
        await this.load()
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.warn-box { border: 1px solid #f0d48a; background: #fff9e8; margin-bottom: 16px; }
.hint { margin: 4px 0 0; font-size: 12px; color: #8a94a6; }
</style>
